import { createStore } from 'vuex'
import login from './modules/login'
import simulations from './modules/simulations'
import generalParameterization from './modules/generalParameterization'
import tracing from './modules/tracing'

export default createStore({
  state() {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: { login, simulations, generalParameterization, tracing },
})
